/* ==================================================
 *  Close
 * ==================================================*/

(function () {

  'use strict';

  $(document).on('click', '[data-close]', function (ev) {
    ev.stopPropagation();

    var target = $(this).attr('data-close');
    var time = 600;

    $(target).removeClass('in');

    setTimeout(function () {
      $(target).removeClass('active');
      $('body').removeClass('overflow-hidden');
    }, time);
  });

})();
